//
//
//
//
//
//

export default {
  name: 'BasicLayout'
};